import React from "react";
import { Link } from "react-router-dom";

export default function ListItem({ recipe }) {
	return (
		<Link
			to={`/recipe/${recipe.id}`}
			style={{
				display: "block", margin: "1rem 0"
			}}>
			<div className="box">
				<article className="media">
					{recipe.photo ? <div className="media-left">
						<figure className="image is-96x96">
							<img src={recipe.photo?.imageUrl} alt={recipe.title} />
						</figure>
					</div> : null}
					<div className="media-content">
						<div className="content">
							<p className="title is-5">{recipe.title}</p>
							<p
								dangerouslySetInnerHTML={{
									__html: recipe.description,
								}}></p>
						</div>
					</div>
				</article>
			</div>
		</Link>
	);
}
